const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`
`);
                this.echo(this.include(context, this.source, this.loadTemplate(`7723950fa229d9e38b7dcd68bb10b3a35001dfaa69f0543ffdbe1406babfa1aa`, `7723950fa229d9e38b7dcd68bb10b3a35001dfaa69f0543ffdbe1406babfa1aa`, 3, 36), undefined, true, false, 3));
                this.echo(`
`);
            }

            getTemplateName() {
                return `7723950fa229d9e38b7dcd68bb10b3a35001dfaa69f0543ffdbe1406babfa1aa`;
            }

            getSourceContext() {
                return new this.Source(``, `7723950fa229d9e38b7dcd68bb10b3a35001dfaa69f0543ffdbe1406babfa1aa`, ``);
            }
        }],
        [36, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `7723950fa229d9e38b7dcd68bb10b3a35001dfaa69f0543ffdbe1406babfa1aa`, 3);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <button class="js-destroy-button">Destroy Subscribe component</button>
    <button class="js-init-button">Initialize Subscribe component</button>

    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/subscribe/subscribe.twig`, undefined, true, false, 8));
                this.echo(`  `);
            }

            getTemplateName() {
                return `7723950fa229d9e38b7dcd68bb10b3a35001dfaa69f0543ffdbe1406babfa1aa`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `7723950fa229d9e38b7dcd68bb10b3a35001dfaa69f0543ffdbe1406babfa1aa`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '7723950fa229d9e38b7dcd68bb10b3a35001dfaa69f0543ffdbe1406babfa1aa');

let template = env.loadTemplate('7723950fa229d9e38b7dcd68bb10b3a35001dfaa69f0543ffdbe1406babfa1aa');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/subscribe/demo/storybook-demo.twig", args: context }
     );
     return rendered;;
};